const CARD_BASE = process.env.NEXT_PUBLIC_CARD_IMAGE_BASE ?? "";

export function getCardImage(identifier: string) {
  if (identifier.startsWith("token:")) {
    const slug = identifier.slice("token:".length);
    return `/card-images_tokens/${slug}.webp`;
  }

  // local fallback if no env var
  if (!CARD_BASE) return `/card-images/${identifier}.webp`;

  // production (R2)
  return `${CARD_BASE}/${identifier}.webp`;
}